import _get from "lodash/get";
import { createAsyncAction } from "./utils";
import { getVisitorProfileByType } from "../selectors/visitor-data";
export var updateVisitorProfile = createAsyncAction('updateVisitorProfile', function (_ref) {
  var profileType = _ref.profileType,
      profileData = _ref.profileData,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? 1 : _ref$version,
      serverRequest = _ref.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      var sdk = opts.UserDataPlatformSDK.profileApi(profileType, version);
      var isProfileInState = !!getVisitorProfileByType(state, profileType); // if we have profile already PATCH otherwise try to create it

      return sdk[isProfileInState ? 'patchMy' : 'postMy'](profileData, serverRequest).catch(function (data) {
        // did the request fail because the profile already exists?
        var profileExistsError = _get(data, 'data.error.data.internal_message') === 'record already exists' && _get(data, 'resp.statusCode') === 422; // if profile exists then attempt to patch it and return that promise

        if (profileExistsError) {
          return sdk.patchMy(profileData, serverRequest);
        } // not an existing profile error throw again so the promise is rejected


        throw data;
      });
    },
    meta: {
      profileType: profileType
    }
  };
});
export var readVisitorProfile = createAsyncAction('readVisitorProfile', function (_ref2) {
  var profileType = _ref2.profileType,
      params = _ref2.params,
      _ref2$version = _ref2.version,
      version = _ref2$version === void 0 ? 1 : _ref2$version,
      serverRequest = _ref2.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      var sdk = opts.UserDataPlatformSDK.profileApi(profileType, version);
      return sdk.getMy(params, serverRequest);
    },
    meta: {
      profileType: profileType
    }
  };
});
export var readVisitorProductShoppingActions = createAsyncAction('readVisitorProductShoppingActions', function (_ref3) {
  var params = _ref3.params,
      serverRequest = _ref3.serverRequest;
  return {
    makeRequest: function makeRequest(state, opts) {
      var sdk = opts.UserDataPlatformSDK.productShoppingActions;
      return sdk.getAllMy(params, serverRequest);
    }
  };
});